import React, { useEffect, useRef, useState } from 'react';
import ProductCard from './ProductCard';
import { DISPLAY, ChevronLeft, ChevronRight } from '../home/ui';

/*
 * Carrusel de productos con pestañas (diseño v1-marketplace).
 * tabs: [{ label, items: [product], tags?: (product) => ['new'|'top'] }]
 * 5 tarjetas por vista en escritorio, 3 en tablet y 2 en móvil; las flechas
 * desplazan una vista completa.
 */
const ProductCarousel = ({ title, tabs }) => {
    const [active, setActive] = useState(0);
    const [edges, setEdges] = useState({ start: true, end: true });
    const trackRef = useRef(null);

    const tab = tabs[active] || tabs[0];
    const items = tab?.items || [];

    const updateEdges = () => {
        const el = trackRef.current;
        if (!el) return;
        setEdges({
            start: el.scrollLeft <= 2,
            end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 2,
        });
    };

    useEffect(() => {
        if (trackRef.current) trackRef.current.scrollLeft = 0;
        updateEdges();
    }, [active, items.length]);

    useEffect(() => {
        window.addEventListener('resize', updateEdges);
        return () => window.removeEventListener('resize', updateEdges);
    }, []);

    const scroll = (dir) => {
        const el = trackRef.current;
        if (el) el.scrollBy({ left: dir * (el.clientWidth + 14), behavior: 'smooth' });
    };

    const arrowCls = 'w-[42px] h-[42px] rounded-[12px] bg-white border-[1.5px] border-[#e8e6e1] text-[#1e3a8a] grid place-items-center transition-all hover:border-[#0891b2] hover:text-[#0891b2] disabled:opacity-40 disabled:hover:border-[#e8e6e1] disabled:hover:text-[#1e3a8a] disabled:cursor-default';

    return (
        <div>
            <div className='flex justify-between items-center gap-[14px] mb-[18px]'>
                <div className='flex items-center gap-[18px] flex-wrap'>
                    <h3 className='font-bold text-[#1e3a8a] text-[26px] m-0 tracking-[-.015em]' style={DISPLAY}>{title}</h3>
                    {tabs.length > 1 && (
                        <div role='tablist' className='flex gap-1 bg-[#faf9f6] border border-[#f1efea] rounded-[14px] p-1 flex-wrap'>
                            {tabs.map((t, i) => (
                                <button key={t.label} role='tab' aria-selected={i === active} onClick={() => setActive(i)}
                                    className={`px-[14px] py-2 rounded-[10px] text-[13px] font-bold transition-all ${i === active ? 'bg-white text-[#1e3a8a] shadow-[0_1px_2px_rgba(15,23,42,.04)]' : 'text-[#64748b] hover:text-[#1e3a8a]'}`}>
                                    {t.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>
                <div className='flex gap-2 flex-shrink-0'>
                    <button aria-label='Anterior' className={arrowCls} onClick={() => scroll(-1)} disabled={edges.start}><ChevronLeft /></button>
                    <button aria-label='Siguiente' className={arrowCls} onClick={() => scroll(1)} disabled={edges.end}><ChevronRight /></button>
                </div>
            </div>

            {items.length === 0 ? (
                <div className='rounded-[18px] border-[1.5px] border-dashed border-[#e8e6e1] bg-[#faf9f6] py-12 text-center text-[14px] text-[#64748b]'>
                    Todavía no hay productos en esta sección.
                </div>
            ) : (
                <div ref={trackRef} onScroll={updateEdges}
                    className='flex gap-[14px] overflow-x-auto snap-x snap-mandatory pt-2 -mt-2 pb-4 -mb-4[scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
                    {items.map(p => (
                        <div key={p._id} className='snap-start flex-shrink-0 w-[calc((100%-56px)/5)] lg:w-[calc((100%-28px)/3)] sm:w-[calc((100%-14px)/2)]'>
                            <ProductCard product={p} tags={tab.tags ? tab.tags(p) : []} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductCarousel;
